import { businessDateTimeLocalFromInstant, businessDateTimeLocalToUtc } from "./business-date"

export function benefitPolicyEditor(policy = {}, kind = "") {
    return {
        kind: kind || policy.kind || "",
        amount: policy.amount_cents == null ? "" : (policy.amount_cents / 100).toFixed(2),
        percent: policy.percent == null ? "" : policy.percent,
        cap: policy.cap_cents == null ? "" : (policy.cap_cents / 100).toFixed(2),
        eligible_items: (policy.eligible_item_codes || []).join("\n"),
        expiry_mode: policy.expiry_mode || (kind === "NON_STOCK" ? "NONE" : "FIXED"),
        expires_at: businessDateTimeLocalFromInstant(policy.expires_at),
        expires_at_original: policy.expires_at || null,
        duration_days: policy.duration_days == null ? "" : policy.duration_days,
        refund_policy: policy.refund_policy || "",
    }
}

export function newBenefitPolicyEditor(kind = "") {
    const edit = benefitPolicyEditor({}, kind)
    if (["AMOUNT_OFF", "PERCENT_OFF"].includes(kind)) edit.refund_policy = "RESTORE_ON_FULL_REFUND"
    return edit
}

export function moneyToCents(value) {
    const match = String(value).trim().match(/^(\d+)(?:\.(\d{1,2}))?$/)
    return match ? Number(match[1]) * 100 + Number((match[2] || "").padEnd(2, "0")) : NaN
}

export function benefitPolicyPayload(edit) {
    const discount = edit.kind === "AMOUNT_OFF" || edit.kind === "PERCENT_OFF"
    return {
        kind: edit.kind,
        ...(edit.kind === "AMOUNT_OFF" ? { amount_cents: moneyToCents(edit.amount) } : {}),
        ...(edit.kind === "PERCENT_OFF" ? { percent: Number(edit.percent) } : {}),
        ...(discount ? {
            cap_cents: moneyToCents(edit.cap),
            eligible_item_codes: [...new Set(String(edit.eligible_items || "").split(/[\n,]/).map((item) => item.trim()).filter(Boolean))],
        } : {}),
        expiry_mode: edit.expiry_mode,
        ...(edit.expiry_mode === "FIXED" ? {
            expires_at: edit.expires_at ? businessDateTimeLocalToUtc(edit.expires_at, edit.expires_at_original) : null,
        } : {}),
        ...(edit.expiry_mode === "DURATION" ? { duration_days: Number(edit.duration_days) } : {}),
        refund_policy: discount ? (edit.refund_policy || null) : null,
    }
}

export function validateBenefitPolicy(policy, voucher = false) {
    if (!["AMOUNT_OFF", "PERCENT_OFF", "NON_STOCK"].includes(policy.kind)) return "Select a benefit type"
    if (policy.kind === "AMOUNT_OFF" && (!Number.isSafeInteger(policy.amount_cents) || policy.amount_cents <= 0)) return "Enter a positive amount with at most two decimal places"
    if (policy.kind === "PERCENT_OFF" && (!Number.isFinite(policy.percent) || policy.percent <= 0 || policy.percent > 100 || Number(policy.percent.toFixed(2)) !== policy.percent)) return "Percentage must be greater than 0, at most 100, with at most two decimal places"
    if (policy.kind !== "NON_STOCK") {
        if (!Number.isSafeInteger(policy.cap_cents) || policy.cap_cents <= 0) return "Enter an explicit positive discount cap with at most two decimal places"
        if (!policy.eligible_item_codes.length) return "Enter the eligible merchandise item codes"
    }
    if (!["FIXED", "DURATION", "NONE"].includes(policy.expiry_mode)) return "Select an expiry mode"
    if (voucher && policy.expiry_mode === "NONE") return "Digital vouchers require a fixed expiry or duration"
    if (policy.expiry_mode === "FIXED" && !policy.expires_at) return "Expiry must be a valid, unambiguous America/Toronto time"
    if (policy.expiry_mode === "DURATION" && (!Number.isSafeInteger(policy.duration_days) || policy.duration_days <= 0)) return "Expiry duration must be a positive whole number of days"
    return ""
}
